/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type AdVehicleStreamManageServiceProgressSubscriptionVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['String']['input']
  }>

export type AdVehicleStreamManageServiceProgressSubscription = {
  __typename?: 'Subscription'
  fccManageServiceProgress: {
    __typename?: 'FccManageServiceProgress'
    vehicleId: string
    sessionId: string
    status: Types.FccManageServiceStatusEnum
    error: {
      __typename?: 'FccManageServiceError'
      code: Types.FccManageServiceErrorCode
    } | null
  }
}

export const AdVehicleStreamManageServiceProgressDocument = gql`
    subscription AdVehicleStreamManageServiceProgress($vehicleId: String!) {
  fccManageServiceProgress(vehicleId: $vehicleId) {
    vehicleId
    sessionId
    status
    error {
      code
    }
  }
}
    `

/**
 * __useAdVehicleStreamManageServiceProgressSubscription__
 *
 * To run a query within a React component, call `useAdVehicleStreamManageServiceProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamManageServiceProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamManageServiceProgressSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamManageServiceProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdVehicleStreamManageServiceProgressSubscription,
    AdVehicleStreamManageServiceProgressSubscriptionVariables
  > &
    (
      | {
          variables: AdVehicleStreamManageServiceProgressSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    AdVehicleStreamManageServiceProgressSubscription,
    AdVehicleStreamManageServiceProgressSubscriptionVariables
  >(AdVehicleStreamManageServiceProgressDocument, options)
}
export type AdVehicleStreamManageServiceProgressSubscriptionHookResult =
  ReturnType<typeof useAdVehicleStreamManageServiceProgressSubscription>
export type AdVehicleStreamManageServiceProgressSubscriptionResult =
  Apollo.SubscriptionResult<AdVehicleStreamManageServiceProgressSubscription>
